import React, { Component } from 'react';
import TopNav from '../components/TopNav';
import { Link, Redirect } from "react-router-dom";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import Axios from 'axios';
import MessageModal from './modal/MessageModal';
import { TextInput, HiddenInput, SwitchInput } from '../components/widget/input/Input';
import LoginModal from './modal/LoginModal';

class CustomerCheckIn extends Component {
    constructor(props) {
        super(props);

        this.state = {
            contact: {
                name: '',
                phone_number: '',
                ic: '',
                firebase_uid: ''
            },
            isFirebaseSignedIn: false,
            isFirebaseLoaded: false,
            showCheckInSuccess: false,
        }
    }

    componentDidMount() {
        this.unregisterAuthObserver = firebase.auth().onAuthStateChanged(
            (user) => {
                //console.log(user)
            })

        this.loadFirebase()

        // Auto show login form after a small delay if not logged in
        if (!customerId) {
            setTimeout(this.showLoginModal, 600)
        }
    }

    loadFirebase = () => {
        let me = this
        let firebase_uid = this.props.app.state.customer.firebase_uid || customerId
        firebase_uid && Axios.get(`/customer/get?firebase_uid=${this.props.app.state.customer.firebase_uid}`)
            .then((res) => {
                console.log(res)
                res && $('#sign-in-div').css('display', 'none')
                res && me.setState({
                    contact: {
                        name: res.data.name || "",
                        phone_number: res.data.phone_number || "",
                        ic: res.data.ic || "",
                        firebase_uid: res.data.firebase_uid
                    },
                    isFirebaseSignedIn: true
                })
            }).catch((error) => {
                console.log(error)
                this.startFirebase()
            }) || this.startFirebase()
    }

    startFirebase = () => {
        return
    }

    showLoginModal = () => {
        this.setState({
            firebaseLoginModal: <LoginModal
                app={this.props.app}
                title={lang.sign_in_one_time}
                onLoginSuccess={(customerData) => {
                    this.setState({ firebaseLoginModal: null, contact: customerData })
                }}
                onClose={() => this.setState({ firebaseLoginModal: null })}
            />
        })
    }

    // Make sure we un-register Firebase observers when the component unmounts.
    componentWillUnmount() {
        this.unregisterAuthObserver()
    }

    onSubmit(values, actions) {
        let data = {
            merchant_id: this.props.app.state.table.merchant_id,
            name: values.name || '',
            phone_number: values.phone_number || '',
            ic: values.ic || '',
            temperature: values.temperature || '',
            firebase_uid: values.firebase_uid || '',
        }

        // confirmDialog.isLoading(true)
        actions.setSubmitting(true)
        Axios.post(`/customer/check_in`, data).then((res) => {
            actions.setSubmitting(false)
            // confirmDialog.close()

            this.setState({
                showCheckInSuccess: true,
            })
        })
        .catch((error) => {
            actions.setSubmitting(false)
            actions.setErrors(error)
            // confirmDialog.close()

            let message = lang.unable_to_place_order_order_manually
            if (error.response.status == 422 && error.response.data.message == message) {

            }
            else {
                message = error.message
            }

            this.setState({
                errorMessage: message
            })
        }).finally(() => {

        })
    }

    render() {
        const {merchant} = this.props.app.state;
        let initalValues = {...this.state.contact}
        let back = `/${this.props.match.params.tableQR}`
        let today = moment().format("YYYY-MM-DD hh:mm a");

        let image_path = (merchant)?merchant.display_logo : "";

        let merchantName = ""
        let branchName = ""
        let isBranch = false
        if(merchant){
            if(merchant.name.indexOf('-') >= 0){
                let arr = merchant.name.split('-');
                merchantName = arr[0];
                branchName = arr[1];
                isBranch = true;
            }
            else{
                merchantName = merchant.name;
            }
        }

        return (
            <div>
                <TopNav table={this.props.app.state.table}
                    title={lang.check_in}
                    orders={this.props.app.state.orders}
                    backLabel={lang.back} back={back} backButton={true}
                    pin={this.props.app.state.current_session !== null && table_session_id !== null ? <button className="btn btn-primary btn-sm" onClick={this.showPinNumber}>{lang.show_pin}</button> : ''}
                    session={this.props.app.state.current_session}
                    tableQR={this.props.match.params.tableQR}
                />

                {this.state.errorMessage && <MessageModal message={this.state.errorMessage} onClose={() => this.setState({errorMessage: null})}/> }
                {this.state.showCheckInSuccess ?
                    <div style={{ textAlign: "center", paddingTop: "60px", paddingRight: '10px', paddingBottom: '10px', paddingLeft: '10px', marginBottom: "20px" }}>
                        <div id="logo" className="clearfix" style={{textAlign:"center"}}>
                            <img src={image_path} style={{ float:"none"}} />
                        </div>
                        {isBranch?
                            <><h3 style={{fontWeight: "bold", marginTop: "10px"}}>{merchantName}</h3><h3 style={{ marginTop: "0px", marginBottom: "0px"}}>{branchName}</h3></> :
                            <h3 style={{fontWeight: "bold", marginTop: "10px"}}>{merchantName}</h3>
                        }
                        <h4 style={{fontWeight: "bold", color: "forestgreen"}}>{lang.check_in_success}</h4>
                        <h2 style={{fontWeight: "bold", color: "forestgreen", fontSize: "28px"}}>{today}</h2>
                        <h4 style={{margin: "20px"}}>{lang.check_in_thank_you}</h4>
                        <Link
                            className="mainpg-btn"
                            to={`/category/${this.props.match.params.tableQR}`}>
                            <span style={{ fontSize: "18px" }}>{lang.menu}</span>
                        </Link>
                    </div>
                    : <div style={{ paddingTop: "60px", paddingRight: '10px', paddingBottom: '10px', paddingLeft: '10px', marginBottom: "20px" }}>
                        <h3 style={{textAlign: "center", fontWeight: "bold", marginTop: "10px"}}>{lang.check_in_title}</h3>
                        <h4>{lang.check_in_purpose}</h4>
                        <Formik
                            initialValues={initalValues}
                            validationSchema={
                                Yup.object().shape({
                                    name: Yup.string().required('Name is required.'),
                                    phone_number: Yup.string().required('Phone Number is required.'),
                                })
                            }
                            enableReinitialize={true}
                            onSubmit={(values, actions) => {
                                this.onSubmit(values, actions)
                            }}>
                            {({
                                handleSubmit,
                                isSubmitting, values }) => {
                                    // const emailHint = !values.email && "* " + lang.fill_in_email_for_ewallet
                                    return <Form onSubmit={handleSubmit}>
                                        <TextInput name='name' label={`${lang.name} *`} />
                                        <TextInput name='phone_number' label={`${lang.phone_number} *`} hint={'Format: 0123456789, no need put +6'} maxLength={11} keyboardType = 'numeric' />
                                        <TextInput name='ic' label={`${lang.identity_card}`} hint={'Format: 121212435858 12 digits, no need put -'} maxLength={12} keyboardType = 'numeric' />
                                        <TextInput name='temperature' label={`${lang.temperature}`} maxLength={4}/>
                                        <HiddenInput name='firebase_uid' />

                                        <div style={{textAlign: "center", margin: "10px"}}>
                                            <button id="btn-confirm-and-pay" style={{width: "50%", fontWeight: "bold"}}
                                                className="btn btn-primary" type="submit" disabled={isSubmitting}>
                                                {lang.check_in}
                                            </button>
                                            <div>
                                                {lang.click_agree} <br/>
                                                <a href="https://www.order-lah.com/privacypolicy.htm">{lang.privacy_policy}</a>
                                            </div>
                                        </div>
                                    </Form>
                                }
                            }
                        </Formik>
                        <h4 style={{textAlign: "center", fontWeight: "bold", color:"darkred"}}>{lang.fight_covid_19}</h4>
                    </div>
                }

                {
                    !customerId && !this.state.showCheckInSuccess &&
                    <div style={{textAlign:"center"}}>
                        <div>{lang.already_has_account}</div>
                        <div>
                            <span className="mainpg-btn" onClick={this.showLoginModal}>
                                <span style={{ fontSize: "18px" }}>{lang.login_to_continue}</span>
                            </span>
                        </div>
                    </div>
                }

                {this.state.firebaseLoginModal}
            </div>
        );
    }
}

CustomerCheckIn.propTypes = {

};

export default CustomerCheckIn;